import { render, staticRenderFns } from "./InsList.vue?vue&type=template&id=854adb20"
import script from "./InsList.vue?vue&type=script&lang=js"
export * from "./InsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports